<template>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        <div class="flex flex-col gap-4">
            <div class="font-bold">Information zu Ihrer Bestellung</div>
            <div>
                <div v-if="getEffiOrderId()">Bestellnummer: {{ getEffiOrderId() }}</div>
                <div>Datum: {{ getDate(order?.created) }}</div>
            </div>
        </div>
        <div class="flex flex-col gap-4">
            <div class="font-bold">Rechnungsadresse</div>
            <div>
                <CheckoutAddress v-if="order" :address="order.invoiceAddress" />
            </div>
        </div>
        <div class="flex flex-col gap-4">
            <div class="font-bold">Lieferadresse</div>
            <div v-if="order?.invoiceAddress?.id == order?.shippingAddress?.id">Identisch mit Rechnungsadresse</div>
            <div v-else>
                <CheckoutAddress :address="order?.shippingAddress" />
            </div>
        </div>
        <div class="flex flex-col gap-4 lg:text-right">
            <div class="font-bold">Zahlungsart</div>
            <div>{{ channel?.localizedProperties['de_DE|SHOP']?.title }}</div>
        </div>
    </div>
</template>
<script setup lang="ts">
import type { NeoPaymentChannel } from '@expert/types';

const props = defineProps({
  order: {
    type: Object as PropType<Order>,
    required: true
  }
});
const channel = ref<NeoPaymentChannel | null>(null);
onMounted(loadData);

async function loadData() {
  const csrf = useCurrentUserState().value?.csrfToken;
  if (!csrf) {
    await wait(100);
    await loadData();
  } else if (props.order.payments?.length > 0) {
    const payment = await getPayedPayment(props.order.payments);
    if (payment && payment.length > 0) {
      channel.value = (await getPaymentChannel(csrf, payment[0].channelId))?.value;
    }
  }
}

function getDate(timestamp:number) {
  if (timestamp) return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(timestamp));
}

function getEffiOrderId() {
  if (props?.order?.customData?.expOrder?.effiOrderId) return props?.order?.customData?.expOrder?.effiOrderId;
  if (props?.order?.shippingOrders?.length > 0) {
    const id = props?.order?.shippingOrders.find(entry => entry.indexOf("_") > -1);
    if (id) return id.substr(id.indexOf('_')+1)
  }
}

</script>